import StationCurveController from './curve.controller';
const template = require<string>('./curve.html');

export default {
  controller: StationCurveController,
  bindings: {
  	stationId: '<'
  },
  template
}



/** WEBPACK FOOTER **
 ** ./app/station/curve/curve.component.ts
 **/